module.exports = __webpack_public_path__ + "media/images/gateway/4-c205a1ab3a222a06f07a875fd4197362.png";